import { useQueryClient } from '@tanstack/react-query';

import { useQuery } from '@hooks/reactQuery';

import { getAlarmHistoryFlexidas } from '@api/alarmHistory';

import { extractQueryParams } from '@utils/common';
import { formatDate } from '@utils/kpi-utils/date';

import { IAlarmHistoryFlexidas } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { EVendorsValues } from '@enums/common';

import { formatTemplateDefault } from '@constants/common';
import { ALARM_HISTORY_FLEXIDAS } from '@constants/queryKeys';

interface IUseQueryAlarmHistoryFlexidasReturn {
	data: IAlarmHistoryFlexidas[];
	countOfRecords: number;
	isLoading: boolean;
	invalidateQuery: () => void;
}

export const useQueryAlarmHistoryFlexidas = (params: IAlarmByVendor): IUseQueryAlarmHistoryFlexidasReturn => {
	const queryClient = useQueryClient();
	const isEnabled = params.vendor === EVendorsValues.flexidas;

	const { isEnabled: isEnabledTab, ...restParams } = params;

	const {
		fromDate,
		toDate,
	} = params;

	const dto = {
		...restParams,
		fromText: fromDate ? formatDate(fromDate, formatTemplateDefault) : null,
		toText: toDate ? formatDate(toDate, formatTemplateDefault) : null,
	};

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ALARM_HISTORY_FLEXIDAS, dto],
		queryFn: extractQueryParams(getAlarmHistoryFlexidas),
		enabled: [isEnabled, isEnabledTab],
		refetchOnWindowFocus: false,
	});

	const invalidateQuery = () => {
		return [queryClient.invalidateQueries([ALARM_HISTORY_FLEXIDAS])];
	};

	return {
		data: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoading: isInitialLoading,
		invalidateQuery,
	};
};
